module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABxSURBVHgB7ZTBCYAwDEVTdQ/dzA0cwknECXQjvTuCENOLhOKlNZQW/oN3+Jd+CkkcM7eUgYYygaJkuiD34kg2rOLxJj91yoXt2PTb4Y9m8SQbdh0c9qj6Ij/ul3gnOMUU/WHQAVNXfhGOagw4qij65gE8QOTGrq+iLAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mIndexMenu.png
// module id = 1GpV
// module chunks = 1